import { useCallback } from "react"
import { Dimension } from "@/services/dimension/dimension.model"
import { UnitEntity } from "@/services/unitSet/unitSet.model"
import { useRequest } from "ahooks"
import { useSelector } from "react-redux"
import { getActiveUnitSet as getActiveUnitSetSelector, getDimensions } from "@/store/project/selector"
import { getActiveUnitSet } from "@/services/unitSet/unitSet.service"


export const useDimUnits = (dimCode: string | undefined): Dimension.Unit[] => {
  const dims = useSelector(getDimensions)
  if (!dimCode) {
    return []
  }
  return dims?.find(item => item.code === dimCode)?.units ?? []
}

export const useGetDimUnits = () => {
  const dims = useSelector(getDimensions)

  return useCallback((dimCode: string | undefined) => {
    if (!dimCode) {
      return []
    }
    return dims?.find(item => item.code === dimCode)?.units ?? []
  }, [dims])
}

export function useGetVariableUnit() {
  const unitSet = useSelector(getActiveUnitSetSelector)
  return useCallback((dimCode: string | undefined): UnitEntity | undefined => {
    if (!(unitSet && dimCode)){
      return;
    }
    return unitSet.units.find(item => item.dimcode === dimCode)
  }, [])
}

export function useLoadVarUnit(projectId: string) {
  const {data: unitSet} = useRequest(() => getActiveUnitSet({projectId: projectId}))

  return useCallback((dimCode: string | undefined): UnitEntity | undefined => {
    if (!(unitSet && dimCode)){
      return;
    }
    return unitSet.units.find(item => item.dimcode === dimCode)
  }, [unitSet])
}